const nameData = "datos"; // Define la entidad dinámica
const nameDataSingular = "pedido"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchCli,searchEmp, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchCli,searchEmp, numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      return {
        dataEntity: data[nameData] || [], 
        totalItems: data.pagination.totalItems || 0,
        totalPage,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};


export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
